export default {
  API_URL: 'https://oneeuston-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://oneeustonsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
